"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkQrStatus = checkQrStatus;
exports.getSecurityToken = getSecurityToken;
exports.getSensitiveOpSetting = getSensitiveOpSetting;
exports.initSopMfaQrCode = initSopMfaQrCode;
exports.sendSopVerificationCode = sendSopVerificationCode;
var _axios = _interopRequireDefault(require("@jdcloud/jelement-biz/dist/api/axios"));
var axios = new _axios.default({
  extra: {
    componentName: 'operation'
  }
});
function initSopMfaQrCode(action) {
  return axios({
    url: '/openApi/sop/initSopMfaQrCode',
    method: 'POST',
    data: {
      params: {
        initSopMfaQrCodeInfo: {
          action: action
        }
      }
    }
  });
}
function checkQrStatus(uuid) {
  return axios({
    url: '/openApi/sop/checkQrStatus',
    method: 'GET',
    params: {
      params: {
        uuid: uuid
      }
    }
  });
}
function getSecurityToken(tokenInfo) {
  return axios({
    url: '/openApi/sop/getSecurityToken',
    method: 'POST',
    data: {
      params: {
        getSecurityTokenInfo: tokenInfo
      }
    }
  });
}
function getSensitiveOpSetting(action) {
  return axios({
    url: '/openApi/sop/getSensitiveOpSetting',
    method: 'GET',
    params: {
      params: {
        action: action
      }
    }
  });
}
function sendSopVerificationCode(action, type) {
  return axios({
    url: '/openApi/sop/sendSopVerificationCode',
    method: 'POST',
    data: {
      params: {
        verificationCodeInfo: {
          action: action,
          type: type
        }
      }
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@jdcloud/jelement-biz/dist/api/operation-protect.js
// module id = GK/q
// module chunks = 19